import { useProdServerAccessList } from "../../Hooks/Features/HelpDesk/useProdServerAccessList"
import RequestPopup from "./RequestPopup";
import { AgGridReact } from "@ag-grid-community/react";
import { SkeletonDataTable } from "../Loader/Loader";
import DatePicker from "react-multi-date-picker";
import { useCommon } from "../../Hooks/Common/useCommon";
import { useTheme } from "../../context/ThemeContext";
import CommonFilterDropdown from "../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
const ProdServerAccessList = () => {

    const { getRequestedData, showRequestPopup, setShowRequestPopup, editData, setEditData, tagRef, dropDownOption, filterValues, setFilterValues, handleStatusChange, loader, columnDefs, rowData, handleRequest } = useProdServerAccessList();
    const { theme } = useTheme();
    const { checkPermission } = useCommon();

    return (
        <div ref={() => checkPermission("help desk", tagRef)}>
            <div ref={tagRef} id='{"tabname": "helpdesk", "data": "server_access_tab"}' >
                <div className="row sk-header-row">
                    <div className="col-md-6 col-12">
                        <div className="row">
                            <div className="col-md-6 col-12">
                                <CommonFilterDropdown
                                    fields={[
                                        { key: "projects", label: "Projects",col:6},
                                        { key: "all_users", label: "Users"},
                                    ]}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues} />
                            </div>
                            <div className="col-md-4 col-12">
                                <DatePicker
                                    value={filterValues?.hoveredRange}
                                    onChange={(e) => { setFilterValues((prev) => ({ ...prev, hoveredRange: e, isChange: true })); }}
                                    range
                                    rangeHover
                                    placeholder="Select Date"
                                    onClose={() => { if (filterValues?.isChange) { getRequestedData(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap justify-content-center align-items-center col-md-4 col-12">
                        {dropDownOption?.statusOptions?.map((item) => (
                            <div key={item?.request_status_id} className="d-flex justify-content-center align-items-center" >
                                <input type="radio" id={item?.request_status_id} name="status" value={item?.request_status_id} onChange={(e) => handleStatusChange(e)} checked={filterValues.status?.request_status_id === item?.request_status_id} className="sk-radio"/>
                                <label htmlFor={item?.request_status_id} className="sk-radio-label"> {item?.request_status_name} </label>
                            </div>
                        ))}
                    </div>
                    <div className="col-md-2 d-flex gap-2 justify-content-end col-12">
                        <button className="sk-btn sk-btn-primary" onClick={() => getRequestedData()}><i className="icon-refresh-outline" /> </button>
                        <button className="sk-btn sk-btn-primary" onClick={() => setShowRequestPopup(true)}><i className="icon-add-outline" /> </button>
                    </div>
                </div>
                <div ref={() => checkPermission("help desk", tagRef)}>
                    <div ref={tagRef} id='{"tabname": "helpdesk", "data": "helpdesk_action_col"}' >
                        <div className="d-flex justify-content-end gap-2 ">
                            <button className="sk-btn sk-btn-primary " onClick={() => handleRequest("is_approved", rowData?.filter(item => item.is_checked === true)?.map(item => item?.server_access_request_id), true)}>Approve All</button>

                            <button className="sk-btn sk-btn-danger " onClick={() => handleRequest("is_rejected", rowData?.filter(item => item.is_checked === true)?.map(item => item?.server_access_request_id), true)}>Reject All</button>
                        </div>

                    </div>
                </div>
                {loader ? <div><SkeletonDataTable numSkeletons={15} /></div> :
                    <div className={`sk-ag-grid ${theme === 'dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'}`} style={{ height: "calc(100vh - 140px)" }}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            rowHeight={30}
                            headerHeight={30}
                        />
                    </div>
                }
                {showRequestPopup && <RequestPopup showRequestPopup={showRequestPopup} setShowRequestPopup={setShowRequestPopup} editData={editData} setEditData={setEditData} callApi={getRequestedData} type="server_access_tab" />
                }
            </div>
        </div>
    )
}

export default ProdServerAccessList